// Properties
export default {
  baseUrl: 'process.env.BASE_URL',
};
